import { deviceLabels } from '@utils/aiAlerts/mapping';
import { get } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  aiAlertMetricSelector,
  includesAiAlertEventWindowSelector,
} from '@store/trends/aiAlerts/selectors';
import { CHART_TYPE } from './utils';
import { getPercentageMetricByKey } from '@utils/metrics/metricHelpers';
import { HIDE_PEAK_VALUE_METRICS } from '@src/components/ai-alerts/constants';

//TODO: move out legend callback

function useLegend({ instance, enabled = false, legendSeriesList = [], metric, chartMode }) {
  const includesAlertWindow = useSelector(includesAiAlertEventWindowSelector);
  const alertMetric = useSelector(aiAlertMetricSelector);
  const percentageMetric = getPercentageMetricByKey({
    metricKey: alertMetric,
    defaultValue: alertMetric,
  });

  const showLegend =
    includesAlertWindow &&
    metric === percentageMetric &&
    chartMode === CHART_TYPE.LINE &&
    !HIDE_PEAK_VALUE_METRICS.includes(alertMetric);

  const toggleLegend = useCallback(() => {
    if (instance) {
      const option = instance.getOption();
      const { legend } = option;

      const toggleState = !get(legend, '0.show', false);
      const topGridSize = toggleState ? 30 : 10;

      instance.setOption({
        legend: { show: toggleState, data: legendSeriesList },
        grid: { top: topGridSize },
      });
    }
  }, [instance, legendSeriesList]);

  // disable impacted device series and allExceptAnomaly by default
  const disableLegendsByDefault = useCallback(() => {
    instance.dispatchAction({
      type: 'legendUnSelect',
      name: deviceLabels.totalCumulativeImpactedUniques,
    });
    instance.dispatchAction({
      type: 'legendUnSelect',
      name: deviceLabels.allExceptAnomaly,
    });
    if (HIDE_PEAK_VALUE_METRICS.includes(alertMetric)) {
      instance.dispatchAction({
        type: 'legendUnSelect',
        name: 'Threshold',
      });
      instance.dispatchAction({
        type: 'legendUnSelect',
        name: 'Baseline',
      });
    }
  }, [instance, alertMetric]);

  const showLegendByDefault = useCallback(() => {
    // only turn on legend for the AI Alert current metric
    if (showLegend) {
      instance.setOption({
        legend: { show: true, data: legendSeriesList },
        grid: { top: 30 },
      });
    }
  }, [instance, legendSeriesList, showLegend]);

  useEffect(() => {
    if (instance && enabled) {
      disableLegendsByDefault();
      showLegendByDefault();
    }
  }, [instance, enabled, disableLegendsByDefault, showLegendByDefault]);

  return { toggleLegend };
}

export default useLegend;

/* TODO: remove post product conirmation about device series

  // turn off all device series
  const handleLegendChange = (params) => {
    const { name, selected } = params;
    const deviceSeriesNames = Object.values(deviceLabels);
    if (deviceSeriesNames.includes(name)) {

      const action = selected[name] ? 'legendSelect' : 'legendUnSelect';

      deviceSeriesNames.filter(seriesName => seriesName !== name)
        .forEach(filteredName => {
          instance.dispatchAction({
            type: action,
            name: filteredName,
          });
        });
    }
  }

  // register chart events
  useEffect(() => {
    if (instance && enabled) {
      instance.on('legendselectchanged', handleLegendChange);
      return () => {
        instance.off('legendselectchanged', handleLegendChange);
      }
    }
  }, [instance, enabled, handleLegendChange]);


*/
